// La conversación con Santi, pieza a pieza (pura, probada). 03-11 (propuesta §5.1): SOLO personas — los separadores de
// día, los globos de Santi y de Pau y la raya «Nuevo». Sin píldoras de turno, sin notas técnicas entre agentes (Pau no
// las ve) y sin tarjeta de apertura: el primer mensaje es la petición, como un globo más.
import { diaLocal } from '../chat/agrupar';
import type { MensajeHiloDTO } from './tipos';
import { YO } from './tiempo';

export type Pieza =
  | { tipo: 'dia'; clave: string; en: string }
  | { tipo: 'nuevo'; clave: string }
  | { tipo: 'globo'; clave: string; m: MensajeHiloDTO; ultimo: boolean };

/**
 * ¿Se pinta como globo? Los mensajes, la petición (apertura) y el cierre con texto, y un pase suelto (el que no fue
 * con un mensaje: «Las llaves ya están… Haced el cambio»). Un pase que fue con un mensaje ya es ese globo; las notas
 * técnicas, nunca.
 */
export function esGlobo(m: MensajeHiloDTO): boolean {
  if (m.tipo === 'nota_tecnica') return false;
  if (m.tipo === 'pase' && m.mensajeSeq) return false;
  return m.texto.trim().length > 0;
}

/**
 * Dónde va la raya «Nuevo»: el seq del primer globo de Santi entre sus `nuevos` últimos (lo que escribió desde la última
 * vez que Pau lo abrió; `nuevos` lo cuenta la oficina). null si no hay nada nuevo.
 */
export function primerNuevo(mensajes: MensajeHiloDTO[], nuevos: number): number | null {
  if (nuevos <= 0) return null;
  const deSanti = mensajes.filter((m) => m.de !== YO && esGlobo(m));
  if (!deSanti.length) return null;
  return deSanti[Math.max(0, deSanti.length - nuevos)]!.seq;
}

export function piezasDelHilo(mensajes: MensajeHiloDTO[], nuevoDesde: number | null = null): Pieza[] {
  const out: Pieza[] = [];
  let dia = '';
  for (const m of [...mensajes].sort((a, b) => a.seq - b.seq)) {
    if (!esGlobo(m)) continue;
    const d = diaLocal(m.en);
    if (d !== dia) {
      out.push({ tipo: 'dia', clave: `dia-${d}`, en: m.en });
      dia = d;
    }
    if (nuevoDesde !== null && m.seq === nuevoDesde) out.push({ tipo: 'nuevo', clave: 'nuevo' });
    out.push({ tipo: 'globo', clave: `g-${m.seq}`, m, ultimo: true });
  }
  // Globos seguidos de la misma persona: solo el último lleva el avatar y la cola (como en el chat del agente).
  for (let i = 0; i < out.length - 1; i += 1) {
    const a = out[i]!;
    const b = out[i + 1]!;
    if (a.tipo === 'globo' && b.tipo === 'globo' && a.m.de === b.m.de) a.ultimo = false;
  }
  return out;
}

/** El último seq del hilo (hasta dónde se marca visto). */
export const ultimoSeq = (mensajes: MensajeHiloDTO[]): number => mensajes.reduce((max, m) => Math.max(max, m.seq), 0);
